<div class="cell auto grid-y cell-block-y blockContent grid-padding-y" *ngIf="study">
    <table class="cell shrink">
        <thead>
        <tr class="_titlePartTable">
            <th [i18nKey]="'studies.external.loads.detail.mixed.charges'"></th>
            <th class="_numberColumn"[i18nKey]="'studies.external.loads.detail.fixed.part'"></th>
            <th class="_numberColumn"[i18nKey]="'studies.external.loads.detail.rate'"></th>
            <th class="_numberColumn"[i18nKey]="'studies.external.loads.detail.variable.part'"></th>
            <th class="_numberColumn"[i18nKey]="'studies.external.loads.detail.total.charges'"></th>
        </tr>
        </thead>

        <kiwi-spacer [size]="16"></kiwi-spacer>

        <tbody>
        <tr>
            <td [i18nKey]="'studies.external.loads.detail.consumables'"></td>
            <td class="_number">{{study.consumablesFixedPart | number:'1.2'}}</td>
            <td class="_number">{{study.consumablesCostTurnoverRate * 100 | number:'1.2'}}</td>
            <td class="_number">{{study.consumablesVariablePart | number:'1.2'}}</td>
            <td class="_number">{{study.consumablesTotalCharges | number:'1.2'}}</td>
        </tr>

        <tr>
            <td [i18nKey]="'studies.external.loads.detail.travel.expenses'"></td>
            <td class="_number">{{study.travelExpensesFixedPart | number:'1.2'}}</td>
            <td class="_number">{{study.travelExpensesRate * 100 | number:'1.2'}}</td>
            <td class="_number">{{study.travelExpensesVariablePart | number:'1.2'}}</td>
            <td class="_number">{{study.travelExpensesTotalCharges | number:'1.2'}}</td>
        </tr>

        <tr>
            <td [i18nKey]="'studies.external.loads.detail.postal.expenses'"></td>
            <td class="_number">{{study.postalFixedPart | number:'1.2'}}</td>
            <td class="_number">{{study.postalChargesRate * 100 | number:'1.2'}}</td>
            <td class="_number">{{study.postalVariablePart | number:'1.2'}}</td>
            <td class="_number">{{study.postalTotalCharges | number:'1.2'}}</td>
        </tr>

        <tr>
            <td colspan="4" class="_totalColumn"[i18nKey]="'studies.external.loads.detail.mixed.charges.total'"></td>
            <td class="_number _totalColumn">{{study.totalMixedCharges | number:'1.2'}}</td>
        </tr>
        </tbody>
    </table>

    <table class="cell shrink">
        <thead>
        <tr class="_titlePartTable">
            <th [i18nKey]="'studies.external.loads.detail.other.charges'"></th>
            <th></th>
        </tr>
        </thead>

        <kiwi-spacer [size]="16"></kiwi-spacer>

        <tbody>
        <tr>
            <td [i18nKey]="'studies.external.loads.detail.maintenance.expenses'"></td>
            <td class="_number">{{study.maintenanceExpenses | number:'1.2'}}</td>
        </tr>

        <tr>
            <td [i18nKey]="'studies.external.loads.detail.advertisement.expenses'"></td>
            <td class="_number">{{study.advertisementExpenses | number:'1.2'}}</td>
        </tr>

        <tr>
            <td [i18nKey]="'studies.external.loads.detail.rent'"></td>
            <td class="_number">{{study.rent | number:'1.2'}}</td>
        </tr>

        <tr>
            <td [i18nKey]="'studies.external.loads.detail.studies.purchase.expenses'"></td>
            <td class="_number">{{study.studiesPurchaseExpenses | number:'1.2'}}</td>
        </tr>

        <tr>
            <td [i18nKey]="'studies.external.loads.detail.insurances.total.cost'"></td>
            <td class="_number">{{study.insurancesTotalCost | number:'1.2'}}</td>
        </tr>

        <tr>
            <td class="_totalColumn"[i18nKey]="'studies.external.loads.detail.other.charges.total'"></td>
            <td class="_number _totalColumn">{{study.totalOtherCharges | number:'1.2'}}</td>
        </tr>

        <tr>
            <td class="_totalColumn"[i18nKey]="'studies.external.loads.detail.total.external.loads'"></td>
            <td class="_number _totalColumn">{{study.totalExternalLoads | number:'1.2'}}</td>
        </tr>

        </tbody>
    </table>

    <kiwi-spacer [size]="16"></kiwi-spacer>

    <div class="turnover">
        <span class="turnover-label"[i18nKey]="'studies.external.loads.detail.turnover'"></span>
        <span class="turnover-value">{{study.totalTurnoverExcludingTax | number:'1.2'}} <span [i18nKey]="'common.change.euros'"></span></span>
    </div>
</div>
